export default __webpack_public_path__ + "static/media/certificat.336ae211.png";